import { Link } from "react-router-dom";
import MarketingLayout from "../marketing/MarketingLayout";
import SiteMeta from "../marketing/SiteMeta";
import { LEGAL_DOCS } from "./legalDocs";
import { MARKETING_ROUTES } from "../marketing/routes";
import "./legalPage.css";
import "./cancellationRefund.css";

const POLICY = LEGAL_DOCS.refund;

function sectionAnchor(heading) {
  return `section-${String(heading).split(" ")[0].replace(/\./g, "-")}`;
}

function PolicyText({ text }) {
  if (!text) return null;
  const parts = text.split(/(Privacy Policy|Terms of Use|Cancellation & Refund Policy)/g);
  return (
    <>
      {parts.map((part, i) => {
        if (part === "Privacy Policy") {
          return <Link key={i} to={MARKETING_ROUTES.privacy}>Privacy Policy</Link>;
        }
        if (part === "Terms of Use") {
          return <Link key={i} to={MARKETING_ROUTES.terms}>Terms of Use</Link>;
        }
        if (part === "Cancellation & Refund Policy") {
          return <strong key={i}>{part}</strong>;
        }
        return <span key={i}>{part}</span>;
      })}
    </>
  );
}

function Blocks({ paragraphs = [], list }) {
  return (
    <>
      {paragraphs.map((p, i) => (
        <p key={`p-${i}`}><PolicyText text={p} /></p>
      ))}
      {list?.length ? (
        <ul className="legal-list">
          {list.map((item) => (
            <li key={item}><PolicyText text={item} /></li>
          ))}
        </ul>
      ) : null}
    </>
  );
}

export default function CancellationRefundPolicyPage() {
  return (
    <MarketingLayout className="legal-page-shell crp-page">
      <SiteMeta title={POLICY.pageTitle} description={POLICY.description} />

      <header className="crp-hero">
        <div className="crp-hero-inner">
          <p className="crp-kicker">Legal</p>
          <h1>{POLICY.title}</h1>
          <p className="crp-dates">
            <span>Effective Date: {POLICY.effectiveDate}</span>
            <span>Last Updated: {POLICY.updated}</span>
          </p>
          {POLICY.intro.map((p) => (
            <p key={p.slice(0, 40)} className="crp-intro"><PolicyText text={p} /></p>
          ))}
        </div>
      </header>

      <div className="crp-layout">
        <nav className="crp-toc" aria-label="Policy sections">
          <p className="crp-toc-title">Contents</p>
          <ol>
            {POLICY.sections.map((section) => (
              <li key={section.heading}>
                <a href={`#${sectionAnchor(section.heading)}`}>{section.heading}</a>
              </li>
            ))}
          </ol>
        </nav>

        <article className="legal-page crp-article">
          {POLICY.sections.map((section) => (
            <section
              key={section.heading}
              id={sectionAnchor(section.heading)}
              className="legal-section"
            >
              <h2>{section.heading}</h2>
              <Blocks paragraphs={section.paragraphs} list={section.list} />
              {section.subsections?.map((sub) => (
                <div key={sub.heading} id={sectionAnchor(sub.heading)} className="legal-subsection">
                  <h3>{sub.heading}</h3>
                  <Blocks paragraphs={sub.paragraphs} list={sub.list} />
                </div>
              ))}
              {section.contact ? (
                <address className="legal-contact">
                  <strong>{section.contact.name}</strong>
                  <p>
                    Email:{" "}
                    <a href={`mailto:${section.contact.email}`}>{section.contact.email}</a>
                  </p>
                  <p>
                    Phone:{" "}
                    <a href={section.contact.phoneHref}>{section.contact.phone}</a>
                  </p>
                  <p>Address: {section.contact.address}</p>
                </address>
              ) : null}
              <Blocks paragraphs={section.afterParagraphs} />
            </section>
          ))}

          <p className="legal-back">
            <Link to={MARKETING_ROUTES.contact}>Contact Us</Link>
            {" · "}
            <Link to={MARKETING_ROUTES.privacy}>Privacy Policy</Link>
            {" · "}
            <Link to={MARKETING_ROUTES.terms}>Terms of Use</Link>
          </p>
        </article>
      </div>
    </MarketingLayout>
  );
}
